<div class="flex w-full justify-center items-center my-2">
  <label
    for="dropzone-file"
    class="flex items-center w-[180px] h-[50px] rounded-lg cursor-pointer theme-bg-2 theme-bg-6--hover mat-elevation-z1"
  >
    <div class="flex items-center justify-center w-[100px] border-r-2">
      <mat-icon>cloud_upload</mat-icon>
    </div>
    <div class="flex flex-col justify-center px-2 w-full">
      <p class="text-sm theme-text-1">
        <span class="font-semibold">Upload a file</span>
      </p>
    </div>
    <input
      id="dropzone-file"
      type="file"
      class="hidden"
      multiple
      (change)="onFileSelected($event)"
      [attr.aria-label]="aria"
    />
  </label>
</div>

@if (attributionMedia.length > 0 && showMedia) {
  <span class="mt-5">Media to upload:</span>
  @for (media of attributionMedia; track $index) {
    <div
      class="flex items-center mt-2 justify-between align-middle w-[450px] rounded-lg theme-bg-1 p-2"
    >
      <span>
        {{ truncateFilename(media.name, 25) }}
      </span>

      <div class="flex items-center space-x-2">
        <span>{{ formatFileSize(media.size) }}</span>
        <button (click)="removeFile($index)">
          <mat-icon class="text-red-500 material-icons-outlined mt-1"
            >delete</mat-icon
          >
        </button>
      </div>
    </div>
  }
}
